import {Component} from '@angular/core';

@Component({
  selector: 'app-skeleton-categories',
  standalone: true,
  imports: [],
  template: `
    <div class="category-grid">
      @for (skeleton of skeletons; track $index) {
        <div class="category-card">
          <div class="skeleton-info">
            <div class="skeleton-name"></div>
            <div class="skeleton-count"></div>
          </div>
          <div class="skeleton-arrow"></div>
        </div>
      }
    </div>
  `,
  styleUrl: './skeleton-categories.scss'
})
export class SkeletonCategories {

  skeletons = Array(6).fill(0);
}
